import React from 'react';
import Grid from 'housecall-ui/dist/DesignSystem/Layout/Grid/Grid';
import Typography from 'housecall-ui/dist/DesignSystem/DataDisplay/Typography/Typography';
import SignpostIcon from 'housecall-ui/dist/IconsAndImages/AppIcons/SignpostAppIcon';
import SignpostButton from '../OtherComponents/SignpostButton';

const SignpostStrategy = {
  headerInfo: {
    name: 'Signpost',
    category: 'Labs',
    details: (
      <>
        <Typography paragraph>
          Signpost helps contractors attract, communicate with, and grow their client base.
          Available on desktop and mobile (iOS and Android), the Signpost platform centralizes leads,
          tracks and facilitates communication across email, text, and chat, and generates great reviews.
          Connect Signpost with Housecall Pro to automate lead intake and client follow-up and focus on
          what you do best.
        </Typography>
      </>
    ),
    iconSvg: <SignpostIcon size="xlarge" />,
  },
  media: {
    youtubeId: 'VN09EKQvCt4',
  },
  price: {
    price: '',
    hideToggle: true,
    appActionButton: <SignpostButton />,
    description:
  <Grid container spacing={8}>
    <Grid item xs={12}>
      <Typography align="right">
        Inquire for pricing
      </Typography>
    </Grid>
  </Grid>,
  },
  sellingPoints: {
    headline: '',
    bottomDescription: (
      <div>
        <div>
          <h4>
            What makes Signpost different from “the other guys”:
          </h4>
          <ul>
            <li>
              Our chat feature is customizable and helps pros communicate, share photos, book appointments,
              and handle ALL of their missed calls (converting missed calls to text). Messaging is customizable,
              and full support is provided during set-up and with ongoing needs.
            </li>
            <li>
              Our mobile app centralizes messages from chat + text + Facebook messenger, enabling pros and teams
              to not only respond to and send messages, but also to send photos and videos. Great for quick diagnosis
              and virtual inspections!
            </li>
            <li>
              Our platform includes robust marketing automation capabilities. We are the
              {' '}
              <strong>only</strong>
              {' '}
              solution that provides monthly newsletter content that pros can customize and send to homeowners,
              so they can share valuable maintenance and other tips, and stay top of mind all year long.
            </li>
            <li>
              We provide flexible payment plans – monthly payments, with no contracts and no hassles.
              Pros are not locked into long-term commitments.
            </li>
          </ul>
        </div>
        <div>
          <h4>What you get with Signpost:</h4>
          <ul>
            <li>Month-to-month pricing, with no long-term commitments or hidden fees</li>
            <li>Unlimited messaging and campaign capabilities</li>
            <li>
              Personalized onboarding, training, and ongoing strategy calls with your dedicated Customer Success Manager
            </li>
          </ul>
        </div>
      </div>
    ),
  },
  supportContacts: [
    {
      type: 'Phone',
      contact: <div><a href="https://www.google.com/search?q=signpost+new+york+ny&rlz=1C5CHFA_enUS894US894&oq=signpost+new+york+ny&aqs=chrome.0.69i59.3232j0j7&sourceid=chrome&ie=UTF-8#" target="_blank" rel="noopener nofollow">(855) 606-4900</a></div>,
    },
    {
      type: 'Email',
      contact: <div><a href="mailto:marketing@signpost.com">marketing@signpost.com</a></div>,
    },
  ],
};

export default SignpostStrategy;
